import { defineComponent as _defineComponent } from 'vue'
import { BigDecimal } from "@/models/store/big.decimal";
import { useConfigurationStore } from "@/store/configuration.store";
import {BigIntWrapper, Coin, DecCoin} from "@/models/store/common";
import FormattedNumber from "./FormattedNumber.vue";

import {PropType} from "vue";
import {useToast} from "vue-toastification";
import i18n from "@/plugins/i18n";

// const props = withDefaults(defineProps<{
//   amount:  bigint | number | BigDecimal | Coin | DecCoin,
//   precision?: number,
//   reduceBigNumber?: boolean,
//   showDenom?: boolean,
//   showTooltip?: boolean
// }>(),{showTooltip: false});



export default /*#__PURE__*/_defineComponent({
  __name: 'CoinAmount',
  props: {
  amount: {
    type:  [BigIntWrapper, Number, BigDecimal, Coin, DecCoin, String] as PropType<BigIntWrapper | number | BigDecimal | Coin | DecCoin | string>,
    required: true,
  },
  precision: {
    type : Number,
    required: false
  },
  reduceBigNumber: {
    type : Boolean,
    required: false
  },
  showDenom: {
    type : Boolean,
    required: false
  },
  showTooltip: {
    type : Boolean,
    required: false,
    default: false
  },
  tooltipOnly: {
    type: Boolean,
    required: false
  },
  denomAsPrefix: {
    type: Boolean,
    required: false
  },
  defaultViewDenom: {
    type : String,
    required: false
  },
  tooltipPrecision:{
    type : Number,
    required: false,
    default: 6
  },
  allowCopyValue:{
    type: Boolean,
    required: false,
    default: true
  }

},
  setup(__props, { expose: __expose }) {
  __expose();

const props =  __props;

function getDenom(): string {
  if (props.amount instanceof Coin || props.amount instanceof DecCoin) {
    return useConfigurationStore().config.getConvertedDenom(props.amount.denom);
  } else {
    if(props.defaultViewDenom){
      return props.defaultViewDenom;
    } else {
      return useConfigurationStore().config.getConvertedDenom();
    }
  }
}

function retrieveConvertedAmount(): number | BigDecimal {
  if (props.amount instanceof Coin || props.amount instanceof DecCoin ) {
    return useConfigurationStore().config.getConvertedAmount(props.amount.amount, props.amount.denom);
  } else if(props.amount instanceof BigIntWrapper){
    return useConfigurationStore().config.getConvertedAmount(props.amount.value);
  } else if(typeof (props.amount) === 'string'){
    return useConfigurationStore().config.getConvertedAmount(Number(props.amount));
  }
  else {
    return useConfigurationStore().config.getConvertedAmount(props.amount);
  }
}

function copyValue(){
  if(props.allowCopyValue) {
    navigator.clipboard.writeText(retrieveConvertedAmount().toFixed(6));
    useToast().success(i18n.global.t('COPY.VALUE'));
  }
}


const __returned__ = { props, getDenom, retrieveConvertedAmount, copyValue, FormattedNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})